import * as DialogPrimitive from '@radix-ui/react-dialog'
import type { ReactNode } from 'react'

export type DialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description?: string
  children: ReactNode
  footer?: ReactNode
}

export function Dialog({ open, onOpenChange, title, description, children, footer }: DialogProps) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="al-dialog__overlay" />
        <DialogPrimitive.Content className="al-dialog__content al-app">
          {/* Close lives at the Content level (not the scrolling body) so it
              stays pinned to the top-right while long forms scroll. */}
          <DialogPrimitive.Close className="al-dialog__close" aria-label="Close">
            {/* Same circle-X used by the cart's remove button and the toast
                dismiss — keeps the close affordance consistent app-wide. */}
            <svg width="22" height="22" viewBox="0 0 38 38" fill="currentColor" aria-hidden="true">
              <path d="M19 38C8.5 38 0 29.5 0 19S8.5 0 19 0s19 8.5 19 19-8.5 19-19 19zm0-36.5C9.4 1.5 1.5 9.4 1.5 19S9.4 36.5 19 36.5 36.5 28.7 36.5 19 28.7 1.5 19 1.5z" />
              <path d="M24.2 24.9c-.2 0-.4-.1-.5-.2L13.3 14.4c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l10.3 10.3c.3.3.3.8 0 1.1-.1.1-.3.2-.5.2z" />
              <path d="M13.9 24.9c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1l10.3-10.3c.3-.3.8-.3 1.1 0s.3.8 0 1.1L14.4 24.7c-.2.1-.4.2-.5.2z" />
            </svg>
          </DialogPrimitive.Close>
          <div className="al-dialog__body">
            <DialogPrimitive.Title className="h3 no-m-t">{title}</DialogPrimitive.Title>
            {description ? (
              <DialogPrimitive.Description>{description}</DialogPrimitive.Description>
            ) : null}
            {children}
            {footer ? <div className="al-dialog__footer">{footer}</div> : null}
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}

export const DialogTrigger = DialogPrimitive.Trigger
